export default "__VITE_ASSET__9CfFnfOy__"